import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {UOMUtil} from '../../utils/uomUtil.js';
import {attachWorkspaceFilterState, readTypeAheadUnitState, restoreTypeAheadUnitState, resolveUnitByCode} from '../../utils/workspaceStateUtil.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {BaseComponent} from '../basecomponent.js';
import {DataTools} from './dataTools.js';


/* global customElements */
class AdminFuelGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var fuelGrid = this;
		setTimeout(function(){
			fuelGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var fuelGrid = this;
		
		var lookupRequestId = 0;
		var loadReferenceLookup = function (refType, lookupValue, selectedUnitId) {
			var requestId = ++lookupRequestId;
			var paging = {
				max: 100
			};
			if (lookupValue) {
				paging.filterField = 'description';
				paging.filterValue = lookupValue;
			}

			var applyItems = function(items) {
				if (requestId !== lookupRequestId) {
					return;
				}
				var unitField = ElementUtil.query(toolbarFilter, 'filterUnitId');
				unitField.items = items;
				if (selectedUnitId) {
					unitField.value = selectedUnitId;
				} else if (!lookupValue) {
					unitField.value = 'UNREF';
				}
			};

			if (!fuelGrid.selectedCompanyId) {
				applyItems([{
					code: 'UNREF',
					description: 'Unreferenced'
				}]);
				return Promise.resolve();
			}

			return UnitService.getUnitLookupService().getUnitsForCompany(
					fuelGrid.selectedCompanyId, refType, paging).then(function (units) {
				if (requestId !== lookupRequestId) {
					return;
				}

				units.data = units.data || [];
				units.data.push({
					code: 'UNREF',
					description: 'Unreferenced'
				});

				if (selectedUnitId && selectedUnitId !== 'UNREF') {
					var found = units.data.some(function(unit) {
						return unit.code === selectedUnitId;
					});
					if (!found) {
						return UnitService.getUnitLookupService().getUnitsForCompany(
								fuelGrid.selectedCompanyId, refType, {
									max: 1,
									filterField: 'code',
									filterValue: selectedUnitId
								}).then(function(matched) {
							if (matched && matched.data && matched.data.length) {
								units.data = matched.data.concat(units.data);
							}
							applyItems(units.data);
						});
					}
				}
				applyItems(units.data);
			});
		};
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [		
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterCompany',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Company',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					postinit: function(combo) {
						if (fuelGrid.accountmanagement) {
							Service.getAccountManagementService().getManagedCompanies().then(function(data){
								var lookups = []; 
								data.forEach(function(c) {
									lookups.push({
										code: c.companyId,
										description: c.companyName
									});
								});
								combo.items = lookups;
							});
						} else {
							Service.getCompanyService().getCompaniesLookup().then(function(data){
								combo.items = data;
							});
						}
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							fuelGrid.selectedCompanyId = ElementUtil.query(toolbarFilter, 'filterCompany').value;
							var unitType = ElementUtil.query(toolbarFilter, 'filterReferenceType');
							loadReferenceLookup(unitType.value, null);
							setTimeout(function(){
								actionRefresh();
							}, 1000);							
						}
					}					
				},				
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterReferenceType',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Equipment Type',
					'item-value-path': 'code',
					'item-label-path': 'description',				
					value: 'TRACTOR',
					postinit: function(combo) {		
						Service.getLookupService().getLookupValues('ReferenceType').then(function (data) {
							var equipment = [];
							data.forEach(function(item){
								if (item.equipmentReference) {
									equipment.push(item);
								}
							});
							combo.items = equipment;
							combo.required = true;
						});
					},
					placeHolder: 'Select',
					listeners: {						
						change: function() {							
							var unitType = ElementUtil.query(toolbarFilter, 'filterReferenceType');
							var unitCB = ElementUtil.query(toolbarFilter, 'filterUnitId');
							loadReferenceLookup(unitType.value, null);
						}
					}
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterUnitId',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Reference',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,					
					postinit: function(combo) {																	
					},
					placeHolder: 'Unreferenced',
					listeners: {
						input: {
							fn: function(e) {
								var unitType = ElementUtil.query(toolbarFilter, 'filterReferenceType');
								loadReferenceLookup(unitType.value, e.target.value);	
							},
							buffer: 500
						},
						change: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterStartDate',
					label: 'Start Date',												
					name: 'filterStartDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.startPreviousMonth());	
					}()
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterEndDate',
					label: 'End Date',												
					name: 'filterEndDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.endPreviousMonth());	
					}()
				}				
			]
		});		
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				}					
			]
		});		
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});			
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'wrap-cell-content row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-select': true,
					'auto-width': true,
					listeners: {
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}					
				},	
				{						
					path: 'recordDts',
					header: 'Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.recordDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},
				{						
					path: 'location.name',
					header: 'Location Name',					
					width: '7em'
				},
				{						
					path: 'location.addressLine1',
					header: 'Address',
					width: '7em'
				},
				{						
					path: 'location.city',
					header: 'City',
					width: '7em'
				},
				{						
					path: 'location.stateProv',
					header: 'State',
					width: '7em'
				},
				{						
					path: 'location.country',
					header: 'Country',
					width: '7em'
				},
				{						
					path: 'purchaseQty',
					header: 'Quantity',
					width: '7em',
					'text-align': 'end'
				},
				{						
					path: 'fuelPriceAmt',
					header: 'Unit Price',
					width: '7em',
					'text-align': 'end'
				},
				{						
					path: 'invoiceNo',
					header: 'Invoice No',
					width: '7em'
				},
				{						
					path: 'unit.originalRefNo',
					header: 'Original Ref No',
					width: '7em'
				},
				{						
					path: 'fuelType',
					header: 'Fuel Type',
					width: '7em'
				},
				{						
					path: 'entryMethodDescription',
					header: 'Entry Method',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'originalFilename',
					header: 'Original Filename',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'comment',
					header: 'Comment',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'updateUser',
					header: 'Update User',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'updateDts',
					header: 'Update Date',
					hidden: true,
					width: '7em',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);
					}
				},
				{						
					path: 'driver.originalRefNo',
					header: 'Driver Ref No',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'taxable',
					header: 'Taxable',
					hidden: true,
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
			
		var gridSelectionChange = function() {
			setTimeout(function(){
				if (grid.selectedItems.length > 0) {
					var totalFuel = 0;
					grid.selectedItems.forEach(function(record) {
						//check quantity UOM and convert as needed
						if (record.quantityUom === 'LITER') {
							totalFuel += UOMUtil.convertLitersToGallons(record.purchaseQty);
						} else {
							totalFuel += record.purchaseQty;
						}
					});
					totalFuel = Math.round(totalFuel * 1000) / 1000;
					
					selectedFuelStatus.innerHTML = '<b>Selected Fuel:</b> ' + totalFuel + ' GALLON | ';
				} else {						
					
					selectedFuelStatus.innerHTML = '';
				}					
			});
		};	
		
		var selectedFuelStatus =  ElementUtil.create({
			tag: 'span'
		});
		
		var fuelStatus =  ElementUtil.create({
			tag: 'span',			
			trustedInnerHTML: true,
			innerHTML: '<b>Fuel:</b> 0 GALLON'
		});				
		
		var exportToolbar = ElementUtil.create({
			tag: 'dl-export-toolbar',
			children: [
				{
					tag: 'span',
					slot: 'status',
					children: [
						selectedFuelStatus,						
						fuelStatus
					]
				}
			],
			listeners: {
				ready: function() {
					exportToolbar.updateGrid(grid);
				},
				'click-detail': function() {
					var companyId = ElementUtil.query(toolbarFilter, 'filterCompany').value;						
					if (companyId) {
						var referenceType = ElementUtil.query(toolbarFilter, 'filterReferenceType').value;
						var unitId = ElementUtil.query(toolbarFilter, 'filterUnitId').value;
						if (referenceType && unitId) {
							DataManagementService.getAdminDataService().exportFuel(companyId,referenceType, unitId, grid.currentFilter);
						} else {
							ElementUtil.query(toolbarFilter, 'filterUnitId').validate();
							ElementUtil.query(toolbarFilter, 'filterReferenceType').validate();
							window.DL.MessageUtil.showToastError('A unit must be selected');
						}
					} else {						
						ElementUtil.query(toolbarFilter, 'filterCompany').validate();
						window.DL.MessageUtil.showToastError('A Company must be selected');
					}
				}
			}
		});
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
									
						var startFilterDts = TimeUtil.startOfDayCompanyTime(ElementUtil.query(toolbarFilter, 'filterStartDate').value);										
						var endFilterDts =  TimeUtil.endOfDayCompanyTime(ElementUtil.query(toolbarFilter, 'filterEndDate').value);		

						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'recordDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',								
							start: startFilterDts,														
							end: endFilterDts,
							dateField: 'recordDts'
						};
																		
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;	
							grid.selectedItems = [];
							gridSelectionChange();
							
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();
							
							var totalFuel = Math.round(records.totalFuel.purchaseQty * 1000) / 1000;
							
							fuelStatus.innerHTML = '<b>Fuel:</b> ' + totalFuel + ' GALLON';							
						};
						
						var companyId = ElementUtil.query(toolbarFilter, 'filterCompany').value;
						
						if (companyId) {
							var referenceType = ElementUtil.query(toolbarFilter, 'filterReferenceType').value;
							var unitId = ElementUtil.query(toolbarFilter, 'filterUnitId').value;
							if (referenceType && unitId) {						
								DataManagementService.getAdminDataService().getFuel(companyId, referenceType, unitId, grid.currentFilter).then(function(records){
									successHandler(records);
								});						
							} else {
								loadMask.remove();
								if (fuelGrid.nextLoadOfGrid) {
									ElementUtil.query(toolbarFilter, 'filterReferenceType').validate();
									ElementUtil.query(toolbarFilter, 'filterUnitId').validate();								
									window.DL.MessageUtil.showToastError('Equipment type and unit must be selected');
								} else {
									fuelGrid.nextLoadOfGrid = true;
								}
							}
						} else {
							loadMask.remove();
							ElementUtil.query(toolbarFilter, 'filterCompany').validate();								
							window.DL.MessageUtil.showToastError('A Company must be selected');
						}						
						
					};	
					
					loadData();														
				};
			},
			listeners: {
				ready: function() {					
					//pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footerContainer = ElementUtil.create({
			tag: 'div',
			slot: 'footer',
			children: [
				exportToolbar,
				{
					tag: 'div',
					style: 'border-top: 1px solid lightgrey;'
				},
				pagingToolbar
			]
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footerContainer
			]
		});		
		fuelGrid.append(flexLayout);			
		
		loadReferenceLookup('TRACTOR', null);
			
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};
		attachWorkspaceFilterState(fuelGrid, toolbarFilter,
			['filterCompany', 'filterReferenceType', 'filterUnitId', 'filterStartDate', 'filterEndDate'],
			actionRefresh,
			{
				save: function(state) {
					var unitState = readTypeAheadUnitState(ElementUtil.query(toolbarFilter, 'filterUnitId'));
					state.filterUnitId = unitState.value;
					state.filterUnitDescription = unitState.description;
				},
				restore: function(data) {
					if (data.filterStartDate !== undefined && data.filterStartDate !== null) {
						ElementUtil.query(toolbarFilter, 'filterStartDate').value = data.filterStartDate;
					}
					if (data.filterEndDate !== undefined && data.filterEndDate !== null) {
						ElementUtil.query(toolbarFilter, 'filterEndDate').value = data.filterEndDate;
					}
					if (data.filterCompany !== undefined && data.filterCompany !== null) {
						ElementUtil.query(toolbarFilter, 'filterCompany').value = data.filterCompany;
						fuelGrid.selectedCompanyId = data.filterCompany;
					}
					var referenceType = data.filterReferenceType;
					if (referenceType !== undefined && referenceType !== null) {
						ElementUtil.query(toolbarFilter, 'filterReferenceType').value = referenceType;
					} else {
						referenceType = ElementUtil.query(toolbarFilter, 'filterReferenceType').value;
					}
					var refType = referenceType || 'TRACTOR';
					restoreTypeAheadUnitState({
						combo: ElementUtil.query(toolbarFilter, 'filterUnitId'),
						refType: refType,
						unitId: data.filterUnitId,
						description: data.filterUnitDescription,
						loadLookup: loadReferenceLookup,
						resolveByCode: function(type, unitId) {
							return resolveUnitByCode(function(referenceType, paging) {
								return UnitService.getUnitLookupService().getUnitsForCompany(
										fuelGrid.selectedCompanyId, referenceType, paging);
							}, type, unitId);
						}
					}).then(function() {
						actionRefresh();
					});
				}
			});
		
	
	}

}
customElements.define('dl-admin-fuel-grid', AdminFuelGrid);





